import React, { useState } from "react";

type Props = {
  targetCompanies: any;
  minCount: number;
};

const MenteeTargetCompanies = ({ targetCompanies, minCount }: Props) => {
  const [showCompanies, setShowCompanies] = useState(minCount);
  return (
    <div className="flex flex-wrap gap-3">
      {targetCompanies
        .slice(0, showCompanies)
        .map((item: any, index: number) => (
          <p
            key={index}
            className="text-[#111111E5] text-xs font-medium py-2 px-3 rounded-lg bg-[#A6C5F7]"
          >
            {item}
          </p>
        ))}
      {targetCompanies.length > minCount &&
        (showCompanies <= minCount ? (
          <p
            className="text-[#111111E5] text-xs font-medium py-2 px-3 rounded-lg bg-[#A6C5F7] cursor-pointer"
            onClick={() => {
              setShowCompanies(targetCompanies.length);
            }}
          >
            +{targetCompanies.length - minCount} More
          </p>
        ) : (
          <p
            className="text-[#111111E5] text-xs font-medium py-2 px-3 rounded-lg bg-[#A6C5F7] cursor-pointer"
            onClick={() => {
              setShowCompanies(minCount);
            }}
          >
            Show Less
          </p>
        ))}
    </div>
  );
};

export default MenteeTargetCompanies;
